import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";



// For Get Comments Of Post
const getAllCommentsOfPostEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ;

export const getAllCommentsOfPostAPI = createAsyncThunk('page/comments' , async (args , thunkAPI) =>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllCommentsOfPostEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments;
    }catch(error){
        return rejectWithValue(error);
    }
})


// For Get The Next Page 
const getNextPostsEndpoint  = (args)=>`${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}&pagingToken=${args.hasNext}` ; 

 export const getNextPostsAPI = createAsyncThunk('extractPagePostsWithId/hasNext' , async (args , thunkaPI)=>{
    const {rejectWithValue} = thunkaPI ; 
    try{
        const response = await axios.get(getNextPostsEndpoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ;
    }
})


// For Get Page Posts With ID API
const getPagePostsIDEndPoint =(args)=> `${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}`;

export const getPagePostsIDAPI = createAsyncThunk('extractPagePostsWithId/getP' , async(args , thunkAPI)=>{
    const response = await axios.get(getPagePostsIDEndPoint(args) , {
        headers : {
            token : args.token
        }
    })
    return response.data
})

// For Default State
const initialState = {
    pagePosts : [] , 
    status : STATUS.IDLE , 
    comments : [] , 
    statusOfComments : STATUS.IDLE , 
    hasNext : ""
}

 const ExtractPagePostsWithIdSlice = createSlice({
    name : "extractPagePostsWithId", 
    initialState ,
    reducers : {
    
    }, 
    extraReducers : (builder)=>{
        builder
        // For Get Page Posts With ID
        .addCase(getPagePostsIDAPI.fulfilled , (state ,action)=>{
            state.status = STATUS.SUCCESS ;
            state.pagePosts = action.payload.pageDetails.data
            state.hasNext = action.payload.pageDetails.paging.next ? action.payload.pageDetails.paging.cursors.after :""
        })
        .addCase(getPagePostsIDAPI.pending , (state ,action)=>{
            state.status = STATUS.LOADDING
        })
        .addCase(getPagePostsIDAPI.rejected , (state ,action)=>{
            state.status = STATUS.ERROR
        })
        // For Get comments 
        .addCase(getAllCommentsOfPostAPI.fulfilled , (state , action)=>{
            state.comments = action.payload ; 
            state.statusOfComments = STATUS.SUCCESS
        })
        .addCase(getAllCommentsOfPostAPI.pending , (state , action)=>{
            state.statusOfComments = STATUS.LOADDING
        })
        .addCase(getAllCommentsOfPostAPI.rejected , (state , action)=>{
            state.statusOfComments = STATUS.ERROR
        })

        // For Get The Next Post
        .addCase(getNextPostsAPI.fulfilled , (state , action)=>{
            state.pagePosts.push(...action.payload.pageDetails.data) ; 
            state.status = STATUS.SUCCESS ; 
            state.hasNext = action.payload.pageDetails.paging.next ? action.payload.pageDetails.paging.cursors.after :""
        })
        .addCase(getNextPostsAPI.pending , (state , action)=>{
            state.status = STATUS.LOADDING ; 
        })
        .addCase(getNextPostsAPI.rejected , (state , action)=>{
            state.status = STATUS.ERROR ; 
        })
    }
})

export default ExtractPagePostsWithIdSlice.reducer ; 

export const getDataWithId = state => state.ExtractPagePostsWithIdSlice

export const getNextWithID = state => state.ExtractPagePostsWithIdSlice.hasNext ; 